<template>
    <span class="counter" id="counter"></span>
</template>

<script type="text/babel">
import { CountUp } from 'countup.js';
import inView from "in-view";

export default {
    props: ["start", "end", "decimals", "suffix"],
    mounted() {
        const _this = this;

        // Counter Settings
        var CountUpOptions = {
            useGrouping: false,
            decimalPlaces: _this.decimals,
            suffix: _this.suffix
        };

        window.addEventListener("load", function() {
            inView(".counter").once("enter", el => {
                // Initialize Counter
                var counterEl = new CountUp(_this.$el,  _this.end, CountUpOptions);
                counterEl.start();
            });
        });
    }
};
</script>